<template>
    <div class="ix-formbuilder-area">

        <div v-if="mode == 'summary'">
            <draggable :list="forms" v-bind="sortElementOptions" ghost-class="ghost" handle=".handle-line">
                <div v-for="(form, index) in forms" :key="index" v-bind="form" class="ix-formbuilder-component-summary">
                    <component
                        :is="form.component"
                        :showIcon="displayIcon"
                        :display-mode="mode"
                        :currentField="form">
                    </component>

                    <div class="ix-formbuilder-component-summary-actions" v-if="displayMode == 'summary'">
                        <button class="ix-btn ix-btn-icon transparent" type="button" @click="duplicateElement(form,index)"><i class="far fa-copy"></i></button>
                        <button class="ix-btn ix-btn-icon transparent" type="button" @click="editElementProperties(form, index)" v-show="form.component != 'Separator'"><i class="far fa-pen"></i></button>
                        <button class="ix-btn ix-btn-icon transparent" type="button" @click="deleteElement(index)"><i class="far fa-trash"></i></button>
                    </div>
                </div>
            </draggable>
        </div>


        <div v-if="mode == 'fillable'">
            <component v-for="(form, index) in forms"
                :key="index"
                :is="form.component"
                :index="index"
                :showIcon="displayIcon"
                :display-mode="mode"
                :currentField="form">
            </component>
        </div>

        <div v-if="mode == 'readable'" class="formbuilder-component">
            <component v-for="(form, index) in forms"
                :key="index"
                :is="form.component"
                :showIcon="displayIcon"
                :display-mode="mode"
                :currentField="form">
            </component>
        </div>

        <div v-if="mode == 'summary' || mode == 'fillable'">
            <input type="hidden" name="form" id="form" :value="JSON.stringify(forms)"/>
            <properties v-show="Object.keys($store.activeForm).length > 0"></properties>
        </div>
    </div>
</template>

<script>
    import { FormBuilder } from "./form_elements/formbuilder";

    export default {
        name: "render-form-builder",
        store: ['forms' , 'activeForm' , 'element', 'formMode'],
        props : {
            showIcon: null,
            displayMode: null,
            content : Array,
            autoSave: null,
            autoSaveUrl: null,
        },
        data() {
            return {
                sortElementOptions: FormBuilder.$data.sortElementOptions,
                displayIcon : this.showIcon,
                mode : this.displayMode,
                formContent: this.content,
                autoSaved: this.autoSave ? this.autoSave : false,
                autoSavedUrl: this.autoSaveUrl ? this.autoSaveUrl : null,
            };
        },
        mounted(){

            this.forms = this.formContent;
            this.formMode = this.mode;
            this.autoSaved = this.autoSave;
            this.autoSavedUrl = this.autoSaveUrl;
            if(document.getElementById('form')){
                this.element = document.getElementById('form');
                this.element.value = this.forms;
                if(this.autoSaved){
                    // Créer un intervalle de 30 secondes
                    setInterval(() => {
                        this.detectChanges();
                    }, 30000);
                }
            }
        },
        components: FormBuilder.$options.components,
                methods: {
            deleteElement(index){
                FormBuilder.deleteElement(index)
            },
            editElementProperties(form, index){
                FormBuilder.editElementProperties(form, index)
            },
            duplicateElement(form , index){
                const clone = JSON.parse(JSON.stringify(form));
                this.forms.splice(index + 1,0,clone);
            },
            showToast(message, type = 'success') {
                const toastHtml = `
                    <div class="toast" style="position: fixed; top: 20px; right: 20px; z-index: 9999;" data-delay="3000">
                        <div class="ix-toast ix-toast-${type}">
                            ${message}
                            <button type="button" class="close" data-dismiss="toast" aria-label="Close">
                                <span aria-hidden="true"><i class="far fa-times"></i></span>
                            </button>
                        </div>
                    </div>
                `;
                
                const toastElement = document.createElement('div');
                toastElement.innerHTML = toastHtml;
                const toastNode = toastElement.firstElementChild;
                document.body.appendChild(toastNode);
                
                
                if (typeof $ !== 'undefined' && $.fn.toast) {
                    $(toastNode).toast('show');
                    
                    $(toastNode).on('hidden.bs.toast', function() {-
                        this.remove();
                    });
                } else {
                    toastNode.style.display = 'block';
                    toastNode.style.opacity = '1';
                    
                    setTimeout(() => {
                        toastNode.style.opacity = '0';
                        setTimeout(() => {
                            toastNode.remove();
                        }, 300);
                    }, 3000);
                }
            },
            detectChanges(){
                this.autoSaved = true;
                if(this.autoSavedUrl){
                    fetch(this.autoSavedUrl, {
                        method: 'PUT',
                        ...this.getHttpJsonRequestHeaders(),
                        ...{
                            body: JSON.stringify({
                                'form' : this.forms,
                            })
                        }
                    }).then((response) => {
                        if(response.status == 200){
                            response.json().then((data) => {
                                this.showToast(data.message, 'success');
                            });
                        } else {
                            response.json().then((data) => {
                                this.showToast(data.message || 'Erreur lors de la sauvegarde', 'error');
                            }).catch(() => {
                                this.showToast('Erreur lors de la sauvegarde automatique', 'error');
                            });
                        }
                    }).catch((error) => {
                        this.showToast('Erreur de connexion lors de la sauvegarde', 'error');
                    });
                }
            }

        }
    }
</script>

<style scoped>
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }

  
</style>
